import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router';
import routes from './routes';
import i18n from './i18n';
import store from './store/index';
import 'material-design-icons-iconfont/dist/material-design-icons.css';

Vue.use(VueRouter);

const router = new VueRouter({
  routes: routes,
  mode: 'history',
  scrollBehavior () {
    return { x: 0, y: 0 };
  }
})

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  let language = to.params.lang;
  if (!language) {
    language = 'en'
  }

  i18n.locale = language;
  next();
})

new Vue({
  vuetify,
  router,
  store,
  i18n,
  el: "#app",
  components: { App },
  template: "<App/>",
  render: (h) => h(App)
}).$mount('#app')
